// Route defaults and temporary screen colors share one ordered native writer.
// A late route callback must never replace the active workout's header color.
export function normalizeHeaderColor(value, fallback = "#1e1e1e") {
  if (typeof value !== "string") return fallback
  const hex = value.trim()
  if (/^#[\da-f]{6}$/i.test(hex)) return hex.toLowerCase()
  if (/^#[\da-f]{3}$/i.test(hex)) return "#" + hex.slice(1).split("").map((c) => c + c).join("").toLowerCase()
  return fallback
}

let routeColor = "#050505"
const overrides = new Map()
let listening = false
let sending = false
let pending = false
let lastSent = null
let generation = 0

function currentColor() {
  const colors = Array.from(overrides.values())
  return colors.length ? colors[colors.length - 1] : routeColor
}

async function flush() {
  if (sending || typeof window === "undefined") return
  const bridge = window.flutter_inappwebview
  if (typeof bridge?.callHandler !== "function") return
  sending = true
  let attemptedColor = null
  let failed = false
  try {
    while (pending) {
      pending = false
      const color = currentColor()
      const revision = generation
      if (color === lastSent) continue
      attemptedColor = color
      const channels = [1, 3, 5].map((i) => parseInt(color.slice(i, i + 2), 16))
      await bridge.callHandler("colorHandler", `rgb(${channels.join(", ")})`)
      if (revision === generation) lastSent = color
    }
  } catch (_) {
    // Keep the latest desired color for platform-ready/resume or the next change.
    lastSent = null
    pending = true
    failed = true
  } finally {
    sending = false
  }
  if (failed && currentColor() !== attemptedColor) flush()
}

function reapply() {
  generation++
  lastSent = null
  pending = true
  flush()
}

function schedule() {
  if (typeof window === "undefined") return
  if (!listening) {
    listening = true
    window.addEventListener("flutterInAppWebViewPlatformReady", reapply)
    window.addEventListener("roodyNativeHeaderReady", reapply)
    window.addEventListener("pageshow", reapply)
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") reapply()
    })
  }
  pending = true
  flush()
}

export default {
  setRouteColor(color) {
    routeColor = normalizeHeaderColor(color, "#050505")
    schedule()
  },
  setOverride(owner, color) {
    overrides.set(owner, normalizeHeaderColor(color))
    schedule()
  },
  clearOverride(owner) {
    overrides.delete(owner)
    schedule()
  },
}
